
// Angular
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

// 3rdparty
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
// Hostware

import SessionStorage from '@app/helpers/SessionStorage';

import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { SignatureDialogComponent } from '@app/dialogs/signature-dialog/signature-dialog.component';
import { Country } from '@app/interfaces/Country';
import { GenericMessage } from '@app/interfaces/generic-message';
import { Subscription } from 'rxjs';
import { GuestDataFields } from '../../../../../froexishared/src/dto/GuestdataFields';
import { SubscriberParameter } from '../../../../../froexishared/src/dto/SubscriberParameter';
import { SubscriberParameterService } from '../../../../../froexishared/src/services/SubscriberParameter.service';
import { AdditionalData } from '@app/dto/AdditionalData';
import { AdditionalDataService } from '@app/services/additional-data.service';
import { RouterOutletService } from '@app/services/router-outlet.service';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { RoomGuest } from '@app/dto/ReservationInfo';
import LocalStorage from '@app/helpers/LocalStorage';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';


@AutoUnsubscribe()
@Component({
  selector: 'app-additional-data',
  templateUrl: './additional-data.component.html',
  styleUrls: ['./additional-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdditionalDataComponent implements OnInit, OnDestroy {

  @ViewChild('accept') accept: MatCheckbox;
  countries: Country[] = [];
  csvLoaded: boolean;
  paramsLoaded: boolean;
  group: FormGroup;
  title: string;
  dataFields: GuestDataFields[] = [];
  modalvisible: boolean = false;
  conditionalFields: string[] = [
    'EMAIL',
    'PHONE',
    'PLATE_NUMBER'
  ];

  loadSubscriberParameter$: Subscription;
  modalVisible: boolean = false;

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0
  acceptText: string = "";
  accepTextOrig: string ="";
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private dialog: MatDialog,
    private translate: TranslateService,
    private subscriberParameterService: SubscriberParameterService,
    private additionDataService: AdditionalDataService,
    public sessionStorageService: SessionstorageService,
    private routerOutletService: RouterOutletService,
    private chatService: ChatService
  ) {

    this.group = this.fb.group({
      EMAIL: new FormControl('', [Validators.email, Validators.maxLength(60)]),
      PHONE: new FormControl('', [Validators.maxLength(30)]),
      PLATE_NUMBER: new FormControl('', Validators.maxLength(20)),
      Accept: new FormControl(false),
    })
    
  }
  //#region =============== Angular Lifecyle events ============================================================================
  ngOnInit() {
    this.accepTextOrig=this.translate.instant('additional_data.terms_and_conditions');

    let termsUrl : string;
    let privacyUrl : string;
    let currLang = this.translate.getLangs();
    if (currLang[0] === 'hu') termsUrl = sessionStorage.getItem('huPrivacyPolicyUrl')
    if (currLang[0] === 'en') termsUrl = sessionStorage.getItem('enPrivacyPolicyUrl');
    if (currLang[0] === 'de') termsUrl = sessionStorage.getItem('dePrivacyPolicyUrl');
    if (currLang[0] === 'fr') termsUrl = sessionStorage.getItem('frPrivacyPolicyUrl');
    if (currLang[0] === 'sk') termsUrl = sessionStorage.getItem('skPrivacyPolicyUrl');
    this.acceptText = this.accepTextOrig.replace("#terms#",termsUrl)

    if (currLang[0] === 'hu') privacyUrl = sessionStorage.getItem('huTermconditionsUrl')
    if (currLang[0] === 'en') privacyUrl = sessionStorage.getItem('enTermconditionsUrl');
    if (currLang[0] === 'de') privacyUrl = sessionStorage.getItem('deTermconditionsUrl');
    if (currLang[0] === 'fr') privacyUrl = sessionStorage.getItem('frTermconditionsUrl');
    if (currLang[0] === 'sk') privacyUrl = sessionStorage.getItem('skTermconditionsUrl');
    this.acceptText = this.acceptText.replace("#privacy#",termsUrl)
    this.chatService.customerFacingDataLength.subscribe(data => { 
      this.messageCounter = data;  
 
      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0  
      }
    })

    this.csvLoaded = true;
    //  group tablet esetén:
    if (LocalStorage.IsTabletMode && LocalStorage.OperationMode !== 'VIP') {
      this.loadSubscriberParameter$ = this.subscriberParameterService.loadByLoadbyHotel3Pid(LocalStorage.Hotel3Pid, 'DATA_FORM').subscribe(result => {
        const sub = result as SubscriberParameter
        this.processDataFormParameter(sub)
      })

    } else {
      this.loadSubscriberParameter$ = this.subscriberParameterService.loadByTypeCode(SessionStorage.GuestData.Subscriber, SessionStorage.GuestData.HotelId, 'DATA_FORM').subscribe(result => {
        const sub = result as SubscriberParameter
        this.processDataFormParameter(sub)
      })
    }

  }
  ngOnDestroy(): void {
    this.loadSubscriberParameter$.unsubscribe()
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
        // this.dialog.open(YesNoDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: { messageText: this.translate.instant('chat.start_chat_question'), messageType: 'CHAT', showIcon: true }
        // }).afterClosed().subscribe(data => {
        //   if (data) {
        //     this.dialog.open(ChatDialogComponent, {
        //       minWidth: '100vw',
        //       height: '100dvh',
        //       data: {
        //         isMinimized: false
        //       }
        //     }).afterClosed().subscribe(data => {
        //       this.badgeValue = 0
        //       this.messageCounterAfterClose = data
        //     })
        //   }
        // })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }

  forwardClick() {

    let additionalData: AdditionalData = new AdditionalData();
    additionalData.GuestStayUuId = SessionStorage.SelectedGuestData.GuestStayUuId;
    additionalData.Hotel3pId = SessionStorage.ReservationInfo.Hotel3pId;
    additionalData.EmailAddress = this.fieldMustShow("EMAIL") ? this.group.controls["EMAIL"].value : "";
    additionalData.PhoneNumber = this.fieldMustShow("PHONE") ? this.group.controls["PHONE"].value : "";
    additionalData.PlateNumber = this.fieldMustShow("PLATE_NUMBER") ? this.group.controls["PLATE_NUMBER"].value : "";


    if (this.dataFields.find(item => item.DataCode == 'SIGNATURE').DataNature != 'N') {
      const dialogRef = this.dialog.open(SignatureDialogComponent,
        {
          disableClose: true,
          hasBackdrop: true,
        })
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          additionalData.Signature = result;
          this.sendAdditionalData(additionalData);
        }
      })
    } else {
      additionalData.Signature = "";
      this.sendAdditionalData(additionalData);
    }
  }


  sendAdditionalData(data: AdditionalData) {
    let message: string
    let messageData: GenericMessage
    let hasError: boolean = false;
    this.additionDataService.SendAdditionalData(data).subscribe({
      next: (result) => {
        messageData = { messageText: this.translate.instant('additional_data.details_save_ok'), messageType: 'INFORMATION', showIcon: true }
        this.showResultDialog(messageData, false)
      },
      error: (err) => {
        hasError = true;
        messageData = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: true }
        this.showResultDialog(messageData, true)
      }
    })
  }

  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================

  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================

  fieldMustShow(data_code: string): boolean {
    const field = this.dataFields.find(item => item.DataCode == data_code);
    return field.DataNature == "N" ? false : true
  }
  fieldRequired(data_code: string): boolean {
    const field = this.dataFields.find(item => item.DataCode == data_code);
    return field.DataNature == "M" ? true : false
  }

  requiredChar(data_code: string): string {
    const field = this.dataFields.find(item => item.DataCode == data_code);
    return field.DataNature == "M" ? '*' : ''
  }

  formValid(): boolean {

    if (this.group.controls["Accept"].value == true && this.group.valid) {
      return true
    } else {
      return false;
    }
  }


  showResultDialog(messageData: GenericMessage, hasError: boolean) {
    this.modalVisible = true;
    const okRef = this.dialog.open(GenericMessageDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      maxWidth: "auto",
      data: messageData
    })

    okRef.afterClosed().subscribe(data => {
      if (!hasError) {
        this.router.navigateByUrl('/checkinstatus')
      }
      if (!this.fieldRequired("EMAIL") && !this.fieldRequired("PHONE") && !this.fieldRequired("PLATE_NUMBER") && !this.fieldRequired("SIGNATURE")) {
        this.router.navigateByUrl('/checkinstatus')
      }
    })
  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  hasFieldToShow(): boolean {
    if (this.dataFields.find(item => item.DataCode == "EMAIL").DataNature == "N"
      && this.dataFields.find(item => item.DataCode == "PLATE_NUMBER").DataNature == "N"
      && this.dataFields.find(item => item.DataCode == "PHONE").DataNature == "N"
      && this.dataFields.find(item => item.DataCode == "SIGNATURE").DataNature == "N") {
      return false;
    } else {
      return true
    }

  }

  processDataFormParameter(param: SubscriberParameter) {
    this.dataFields = JSON.parse(param.Param_Json_Value) as GuestDataFields[];
    // this.dataFields.find( item=> item.DataCode=="EMAIL").DataNature="M"
    this.conditionalFields.forEach(field => {
      if (this.fieldMustShow(field) && this.fieldRequired(field)) {
        if (field == "EMAIL") {
          this.group.controls[field].setValidators([Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]);
        } else {
          this.group.controls[field].setValidators(Validators.required);
        }
        this.group.controls[field].updateValueAndValidity();
      }
    })
    this.paramsLoaded = true;
  }
}
//#endregion =================================================================================================================





/*
 EMAIL: new FormControl('', Validators.email),
      PHONE: new FormControl(''),
      PLATE_NUMBER: new FormControl(''),

*/